import { Accordion, AccordionSummary, AccordionDetails, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { alpha } from '@mui/material/styles';
import PropTypes from 'prop-types';

AlertAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.node,
  defaultExpanded: PropTypes.bool,
};

export default function AlertAccordion({ title, color = 'error', icon, children, defaultExpanded = false }) {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{
        borderRadius: '8px !important',
        border: '1px solid rgba(43, 45, 47, 0.24)',
        borderLeft: (theme) => `3px solid ${theme.palette[color]?.main || color}`,
        overflow: 'hidden',
        boxShadow: 'none',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          p: '8px 14px',
          minHeight: '36px !important',
          height: '36px',

          backgroundColor: (theme) => alpha(theme.palette[color]?.main || color, 0.1),
          '& .MuiAccordionSummary-content': { m: 0 },
          '& .MuiAccordionSummary-expandIconWrapper': {},
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            py: 1,
          }}
        >
          {icon}
          <Typography fontSize={'12px'}>{title}</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: '8px 16px' }}>{children}</AccordionDetails>
    </Accordion>
  );
}
